<!--
 * @Author: jjchen
 * @Date: 2022-08-12 11:23:29
 * @LastEditors: lz
 * @LastEditTime: 2022-10-10 15:56:23
 * @Description: 完成报告页
-->
<template>
  <div class="completeReport">
    <div class="cover">
      <svg-icon icon-class="gxbg-cover" class="gxbg-cover"></svg-icon>
      <div class="contentOne">
        <svg-icon icon-class="gx-cover" class="gx-cover"></svg-icon>
        <div>专业版</div>
      </div>
      <div class="contentTwo">高新技术企业测评报告</div>
      <div class="contentThree">
        <div class="companyName">{{ reportContent.companyName }}</div>
        <div class="reportInfo">报告时间：{{ buildTime }}</div>
        <!-- <div class="reportInfo">
          报告出具单位：汉唐信通（北京）咨询股份有限公司
        </div> -->
      </div>
      <div class="coverFooter">
        声明：评测结果为公司宝基于用户选择结果和企业大数据通过算法计算分析的结果，数据仅供参考，并非最终申报成功与否的保证或承诺，不具备法律效力。
      </div>
    </div>
    <div class="companyInfo">
      <div class="leftInfo"></div>
      <div
        :class="reportContent.comprehensive < 10 ? 'numStyle' : 'num'"
        v-if="reportContent.comprehensive !== '100'"
      >
        {{ reportContent.comprehensive }}
      </div>
      <div class="specialNum" v-else>{{ reportContent.comprehensive }}</div>
      <div class="numText">综合指数</div>
      <div class="rightInfo">
        <div class="compName">{{ reportContent.companyName }}</div>
        <div class="compInfo createTime">
          成立时间：{{ reportContent.fromTime }}
        </div>
        <div class="compInfo">
          主要产品(服务)所属国家高新技术领域：{{ reportContent.industry }}
        </div>
        <img src="@/assets/images/gx-right.png" alt="" />
      </div>
    </div>
    <div class="figure">
      <img src="@/assets/images/gx-top.png" alt="" />
      <div class="figureTitle">综合能力图</div>
      <div class="line"></div>
      <div class="canvasDao">
        <radarMap :radarData="abilityScore" class="canvas" />
      </div>
    </div>
    <div class="table">
      <div class="tableHead">
        <div class="columnOne column">能力名称</div>
        <div class="columnTwo columnA">预估指数</div>
        <div class="columnThree columnB">能力星级</div>
        <div>测评说明（仅供参考）</div>
      </div>
      <div class="tableBody">
        <div class="content" v-for="(item, index) in abilityInfo" :key="index">
          <div class="border"></div>
          <div class="abilityName columnOne">
            <span>{{ item.name }}</span>
          </div>
          <div class="index columnTwo">
            <span>{{ item.score }}</span>
          </div>
          <div class="star columnThree">
            <van-rate
              v-model="starLevel.levelOne"
              allow-half
              :size="10"
              color="#FF9C00"
              v-if="index == 0"
            />
            <van-rate
              v-model="starLevel.levelTwo"
              allow-half
              :size="10"
              color="#FF9C00"
              v-if="index == 1"
            />
            <van-rate
              v-model="starLevel.levelThree"
              allow-half
              :size="10"
              color="#FF9C00"
              v-if="index == 2"
            />
            <van-rate
              v-model="starLevel.levelFour"
              allow-half
              :size="10"
              color="#FF9C00"
              v-if="index == 3"
            />
          </div>
          <div class="desc">
            <span v-html="item.description">{{ item.description }}</span>
          </div>
        </div>
        <!-- <div class="mask" v-if="isAdvisory">
          <van-button type="info" class="plan" @click="show = true"
            >立即获取优化建议及行业解决方案</van-button
          >
        </div> -->
      </div>
    </div>
    <div class="table" v-if="reportContent.comprehensive < 100">
      <div class="tableHead">
        <div class="adviseTitle">优化建议</div>
      </div>
      <div class="tableBody">
        <div class="advise">
          <div class="suggest" v-for="(item, index) in advice" :key="index">
            <div>{{ index + 1 }}、</div>
            <div>{{ item }}</div>
          </div>
        </div>
        <!-- <div class="mask" v-if="isAdvisory">
          <van-button type="info" class="plan" @click="show = true"
            >立即获取优化建议及行业解决方案</van-button
          >
        </div> -->
      </div>
    </div>
    <div class="note">
      <div v-for="(item, index) in note" :key="index">{{ item }}</div>
    </div>
    <!-- <div class="reportButton" v-if="!(this.$route.query.sc && this.$route.query.sc === 'zgzx')">
      <van-button type="info" @click="show = true"
        >立即获取优化建议及行业解决方案</van-button
      >
    </div> -->
    <declareConsult
      :show.sync="show"
      :companyName="companyName"
      @changeMask="changeMask"
    />
    <!-- 返回小程序 -->
    <div v-if="isWxEnv" class="back">
      <div class="back-wrap" @click="goback">
        <span>返回</span>
        <img src="@/assets/images/H5/back.png" alt="" srcset="" />
      </div>
    </div>
  </div>
</template>
<script>
import { getViewReportApi, checkAdvisoryApi } from "@/api/enterpriseHighNewH5";
import radarMap from "./components/radarMap.vue";
import declareConsult from "./components/declareConsult.vue";
export default {
  components: {
    radarMap,
    declareConsult,
  },
  data() {
    return {
      isWxEnv: false, // 是否在微信小程序打开
      buildTime: "",
      reportContent: {},
      abilityInfo: [],
      abilityScore: [],
      show: false,
      companyName: "",
      starLevel: {
        //能力星级
        levelOne: 0,
        levelTwo: 0,
        levelThree: 0,
        levelFour: 0,
      },
      advice: [],
      isAdvisory: false, //是否留咨
      reportId: "",
      note: [
        "备注说明：",
        "（1）Ⅰ类知识产权=发明专利+植物新品种+国家级农作物新品种+ 国家新药+国家一级中药保护品种+国家一级中药保护品种+集成电路布图设计专有权",
        "（2）Ⅱ类知识产权=实用新型专利+外观设计专利+软件著作权",
        "（3）净资产增长率=1/2（第二年末净资产÷第一年末净资产+第三年末净资产÷第二年末净资产）-1",
        "（4）销售收入增长率=1/2（第二年销售收入÷第一年销售收入+第三年销售收入÷第二年销售收入）-1",
        "以上分数是测评工具和系统深度学习样本后计算的结果，仅供参考。",
      ],
    };
  },
  created() {
    this.isWx().then((type) => {
      // this.$notify({
      //   type: "warning",
      //   message: type,
      // });
      this.isWxEnv = type == "mini-wx";
    });
    if (this.$route.query.userId) {
      let userInfo = {
        userId: this.$route.query.userId,
        username: this.$route.query.username,
        orgId: this.$route.query.orgId,
        orgName: this.$route.query.orgName,
      };
      if (this.$route.query.applets) {
        userInfo.applets = this.$route.query.applets;
      }
      localStorage.setItem("userInfo", JSON.stringify(userInfo));
    }
  },
  mounted() {
    if (this.$route.query.reportId) {
      this.reportId = this.$route.query.reportId;
    }
    this.getViewReport();
    this.checkAdvisory();
  },
  methods: {
    //函数
    isWx() {
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return new Promise((resolve) => {
          this.$wx.miniProgram.getEnv(function(res) {
            if (res.miniprogram) {
              resolve("mini-wx");
            } else {
              resolve("wx");
            }
          });
        });
      } else {
        console.log("不在微信里");
        return new Promise((resolve) => {
          resolve("no-wx");
        });
      }
    },
    goback() {
      this.$wx.miniProgram.navigateTo({
        url: "/pages/index/index",
      });
    },
    // 留咨后去掉遮挡
    changeMask() {
      this.isAdvisory = false;
    },
    async getViewReport() {
      const res = await getViewReportApi({
        reportId: this.reportId,
      });
      if (res.code == 0) {
        this.buildTime = res.data.buildTime;
        this.reportContent = res.data.reportContent;
        this.companyName = this.reportContent.companyName;
        this.advice = this.reportContent.suggest;
        this.abilityInfo.push(
          this.reportContent.intellectual,
          this.reportContent.science,
          this.reportContent.growUp,
          this.reportContent.research
        );
        this.abilityInfo.forEach((item) => {
          this.abilityScore.push(item.score);
        });
        this.starLevel.levelOne = this.abilityScore[0] / 6;
        this.starLevel.levelTwo = this.abilityScore[1] / 6;
        this.starLevel.levelThree = this.abilityScore[2] / 4;
        this.starLevel.levelFour = this.abilityScore[3] / 4;
      } else {
        if (process && process.env.VUE_APP_MODE === "test") {
          location.href = `https://mtest.gongsibao.com/web/login.html?url=https://policytest.gongsibao.com/enterpriseHighNewH5/completeReport?reportId=${this.reportId}`;
        } else if (process && process.env.VUE_APP_MODE === "prod") {
          location.href = `https://m.gongsibao.com/web/login.html?url=https://policy.gongsibao.com/enterpriseHighNewH5/completeReport?reportId=${this.reportId}`;
        }
      }
    },
    // 是否留咨
    async checkAdvisory() {
      const res = await checkAdvisoryApi();
      if (res.code == 0) {
        if (res.data.isAdvisory) {
          // 留咨不遮挡
          this.isAdvisory = false;
        } else {
          // 未留咨遮挡
          this.isAdvisory = true;
        }
      } else {
        this.isAdvisory = false;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.completeReport {
  padding-top: 0.3rem;
  .back {
    position: sticky;
    left: 1.93rem;
    bottom: 0.59rem;
    z-index: 999;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .back-wrap {
      height: 100%;
      width: 3.6rem;
      height: 0.64rem;
      background: #edf1fd;
      box-shadow: 0px 0.02rem 0.06rem 0.04rem rgba(221, 230, 255, 1);
      border-radius: 0.38rem;
      border: 1px solid #385eef;
      font-size: 0.34rem;
      font-weight: 500;
      color: #5370ff;
      display: flex;
      align-items: center;
      justify-content: center;
      span {
        margin-right: 0.28rem;
      }
      img {
        width: 0.39rem;
        height: 0.38rem;
      }
    }
  }
  .cover {
    width: 7.1rem;
    height: 9.78rem;
    background: #3264fd;
    position: relative;
    margin: 0 auto 0.2rem auto;
    color: #ffffff;
    .gxbg-cover {
      width: 6.9rem;
      height: 9.78rem;
      position: absolute;
      top: 0;
      left: 0;
    }
    .contentOne {
      position: absolute;
      top: 0.97rem;
      right: 0.5rem;
      text-align: center;
      .gx-cover {
        width: 0.53rem;
        height: 0.53rem;
      }
      div {
        font-size: 0.18rem;
        color: #b3dbff;
      }
    }
    .contentTwo {
      position: absolute;
      top: 3.35rem;
      left: 1.05rem;
      font-size: 0.4rem;
      font-weight: 800;
    }
    .contentThree {
      position: absolute;
      top: 6rem;
      right: 0.4rem;
      text-align: right;
      .companyName {
        font-size: 0.28rem;
        font-weight: bold;
        margin-bottom: 0.29rem;
      }
      .reportInfo {
        font-size: 0.22rem;
        color: #b3dbff;
      }
      :last-child {
        margin-top: 0.12rem;
      }
    }
    .coverFooter {
      position: absolute;
      left: 0.4rem;
      bottom: 0.2rem;
      width: 6.1rem;
      font-size: 0.16rem;
      color: #76a2ff;
    }
  }
  .companyInfo {
    width: 7.1rem;
    height: 2.59rem;
    box-shadow: 0px 4px 14px 0px rgba(237, 243, 253, 0.47);
    border-radius: 4px;
    display: flex;
    position: relative;
    margin: 0 auto;
    .leftInfo {
      width: 2.4rem;
      height: 100%;
      background: linear-gradient(315deg, #79aaff 0%, #4471ff 100%);
      opacity: 0.14;
      text-align: center;
    }
    .num {
      font-size: 0.7rem;
      font-weight: 600;
      color: #4471ff;
      position: absolute;
      top: 0.5rem;
      left: 0.78rem;
    }
    .numStyle {
      font-size: 0.7rem;
      font-weight: 600;
      color: #4471ff;
      position: absolute;
      top: 0.5rem;
      left: 1rem;
    }
    .specialNum {
      font-size: 0.7rem;
      font-weight: 600;
      color: #4471ff;
      position: absolute;
      top: 0.5rem;
      left: 0.58rem;
    }
    .numText {
      font-size: 0.24rem;
      color: #4471ff;
      position: absolute;
      top: 1.5rem;
      left: 0.72rem;
    }
    .rightInfo {
      width: 4.69rem;
      padding: 0.3rem 0 0.2rem 0.23rem;
      border: 1px solid rgba(0, 114, 247, 0.07);
      border-left: none;
      position: relative;
      .compName {
        width: 4.16rem;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 0.26rem;
        font-weight: 500;
      }
      .createTime {
        margin-top: 0.18rem;
        margin-bottom: 0.12rem;
      }
      .compInfo {
        width: 4.06rem;
        font-size: 0.24rem;
        color: #666666;
      }
      img {
        width: 0.79rem;
        height: 1.02rem;
        position: absolute;
        bottom: 0;
        right: 0;
      }
    }
  }
  .figure {
    width: 7.1rem;
    height: 6.41rem;
    box-shadow: 0px 4px 14px 0px rgba(237, 243, 253, 0.47);
    border-radius: 4px;
    border: 1px solid rgba(0, 114, 247, 0.07);
    margin: 0.2rem auto 0 auto;
    position: relative;
    img {
      height: 0.9rem;
    }
    .figureTitle {
      font-size: 0.28rem;
      color: #356eff;
      position: absolute;
      top: 0.7rem;
      left: 2.85rem;
    }
    .line {
      width: 1.4rem;
      height: 0.04rem;
      background: linear-gradient(
        270deg,
        rgba(121, 170, 255, 0) 0%,
        #4471ff 100%
      );
      margin: 0.25rem auto 0 auto;
    }
    .canvasDao {
      width: 7.1rem;
      height: 5rem;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    // .canvas {
    //   position: absolute;
    //   top: -1rem;
    //   right: -3.18rem;
    //   // left: 50%;
    //   // transform: translate(-50%, 0);
    // }
  }
  .table {
    width: 7.1rem;
    margin: 0.2rem auto 0 auto;
    box-shadow: 0px 4px 14px 0px rgba(237, 243, 253, 0.47);
    border-radius: 4px;
    font-size: 0.24rem;
    // padding-bottom: 0.21rem;
    .columnOne {
      width: 1.36rem;
    }
    .columnTwo {
      width: 1.23rem;
    }
    .columnThree {
      width: 1.5rem;
    }
    .tableHead {
      height: 0.7rem;
      background: #eef2ff;
      border-radius: 4px 4px 0px 0px;
      line-height: 0.7rem;
      display: flex;
      .column {
        padding-left: 0.2rem;
      }
      .columnA {
        text-align: center;
      }
      .columnB {
        padding-left: 0.1rem;
      }
      .adviseTitle {
        margin-left: 0.2rem;
      }
    }
    .advise {
      padding: 0.4rem 0.2rem;
      border: 1px solid #edf5fe;
      .suggest {
        margin-bottom: 0.15rem;
        display: flex;
      }
      :last-child {
        margin-bottom: 0;
      }
    }
    .tableBody {
      position: relative;
      .mask {
        width: 100%;
        height: 100%;
        background: linear-gradient(180deg, #f6f9ff 0%, #ffffff 100%);
        border-radius: 4px;
        opacity: 0.97;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 999;
        display: flex;
        align-items: center;
        justify-content: center;
        .plan {
          width: 4.9rem;
          height: 0.7rem;
          background: linear-gradient(310deg, #62aaff 0%, #3371ff 100%);
          border-radius: 4px;
          font-size: 0.28rem;
          font-weight: 500;
        }
      }
      .content {
        // height: 3.85rem;
        border: 1px solid #edf5fe;
        border-top: none;
        min-height: 2.92rem;
        display: flex;
        align-items: center;
        position: relative;
        .border {
          position: absolute;
          left: 1.42rem;
          width: 1px;
          height: 100%;
          background: #edf5fe;
        }
        &::before {
          content: "";
          position: absolute;
          left: 2.42rem;
          width: 1px;
          height: 100%;
          background: #edf5fe;
        }
        &::after {
          content: "";
          position: absolute;
          left: 3.79rem;
          width: 1px;
          height: 100%;
          background: #edf5fe;
        }
        .abilityName {
          height: 100%;
          padding-left: 0.2rem;
        }
        .index {
          height: 100%;
          color: #ff6d33;
          text-align: center;
        }
        .star {
          margin: 0 auto;
        }
        .desc {
          width: 2.9rem;
          // height: 3.24rem;
          margin: 0.2rem;
        }
      }
    }
  }
  .note {
    width: 7.1rem;
    height: 5.92rem;
    background: #f9f9f9;
    border-radius: 4px;
    padding: 0.32rem;
    margin: 0.3rem auto;
    font-size: 0.22rem;
    color: #666666;
    div {
      margin-bottom: 0.3rem;
    }
    :last-child {
      margin-bottom: 0;
    }
  }
  .reportButton {
    height: 1.5rem;
    box-shadow: 0px 2px 15px 5px #eff5fa;
    display: flex;
    justify-content: center;
    align-items: center;
    .van-button {
      width: 6.9rem;
      height: 0.8rem;
    }
    .van-button--info {
      background-color: #0072f7;
      border: none;
    }
  }
}
</style>
